import logo200Image from "../../assets/img/logo/nepal.png";
import logopdrc from "../../assets/img/logo/pdrc_logo.png";
import PropTypes from "prop-types";
import React from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { login } from "./action";
import {
  isSuperAdmin,
  isPalikaAdmin,
  getAccessToken,
  getUser,
} from "../../utlis";
import _ from "lodash";
import Typography from "@material-ui/core/Typography";
class AuthForm extends React.Component {
  stat = {
    username: "",
    password: "",
  };
  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }

  get isSignup() {
    return this.props.authState === STATE_SIGNUP;
  }
  componentDidMount() {
    if (getUser()) this.props.history.push("/");
  }

  changeAuthState = (authState) => (event) => {
    event.preventDefault();

    this.props.onChangeAuthState(authState);
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const res = await this.props.dispatch(login(this.state));
    const status = _.get(res, "value.status");
    console.log("res", res);
    if (status == 200) {
      // if(!isSuperAdmin()){
      this.props.history.push("/");
      // }else{
      // window.location.replace("/");
      // }
    }
  };

  renderButtonText() {
    const { buttonText } = this.props;

    if (!buttonText && this.isLogin) {
      return "Login";
    }

    // if (!buttonText && this.isSignup) {
    //   return 'Signup';
    // }

    return buttonText;
  }
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ ...this.state, [name]: value });
  };
  render() {
    const {
      showLogo,
      usernameLabel,
      usernameInputProps,
      passwordLabel,
      passwordInputProps,
      confirmPasswordLabel,
      confirmPasswordInputProps,
      children,
      onLogoClick,
      LoginReducer,
    } = this.props;
    const { loginState, error } = LoginReducer;
    console.log("error ", error);
    return (
      <Form onSubmit={this.handleSubmit}>
        {showLogo && (
          <div className="text-center pb-4">
            <img
              src={logo200Image}
              className="rounded"
              style={{ width: 60, height: 60, cursor: "pointer" }}
              alt="logo"
              onClick={onLogoClick}
            />
          </div>
        )}
        <Typography variant="h5" align="center">
          {" "}
          परिवार स्वास्थ्य फोल्डर Login
        </Typography>
        {/* <Typography ali></Typography> */}
        {loginState === 3 && (
          <p style={{ color: "red", padding: "10px 5px" }}>{error}</p>
        )}
        <FormGroup>
          <Label for={usernameLabel}>Username</Label>
          <Input
            {...usernameInputProps}
            onChange={this.handleChange}
            name="username"
          />
        </FormGroup>
        <FormGroup>
          <Label for={passwordLabel}>Password</Label>
          <Input
            {...passwordInputProps}
            onChange={this.handleChange}
            name="password"
          />
        </FormGroup>
        {this.isSignup && (
          <FormGroup>
            <Label for={confirmPasswordLabel}>{confirmPasswordLabel}</Label>
            <Input {...confirmPasswordInputProps} />
          </FormGroup>
        )}
        <FormGroup check>
          <Label check>
            <Input type="checkbox" />{" "}
            {this.isSignup ? "Agree the terms and policy" : "Remember me"}
          </Label>
        </FormGroup>
        <hr />
        <Button
          size="lg"
          className="bg-gradient-theme-left border-0"
          block
          onClick={this.handleSubmit}
        >
          {this.renderButtonText()}
        </Button>

        <div className="text-center pt-1">
          <h6>
            {this.isSignup ? (
              <a href="#login" onClick={this.changeAuthState(STATE_LOGIN)}>
                Login
              </a>
            ) : (
              <a href="#signup" onClick={this.changeAuthState(STATE_SIGNUP)}>
                {/* Signup */}
              </a>
            )}
          </h6>

          <Typography variant="button">
            Powerd BY :
            <img
              src={logopdrc}
              className="rounded"
              style={{ width: 50, height: 50, cursor: "pointer" }}
              alt="logo"
              // onClick={logopdrc}
            />
          </Typography>
        </div>

        {children}
      </Form>
    );
  }
}

export const STATE_LOGIN = "LOGIN";
export const STATE_SIGNUP = "SIGNUP";

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
};

AuthForm.defaultProps = {
  authState: "LOGIN",
  showLogo: true,
  usernameLabel: "Email",
  usernameInputProps: {
    type: "email",
    placeholder: "your@email.com",
  },
  passwordLabel: "Password",
  passwordInputProps: {
    type: "password",
    placeholder: "your password",
  },
  confirmPasswordLabel: "Confirm Password",
  confirmPasswordInputProps: {
    type: "password",
    placeholder: "confirm your password",
  },
  onLogoClick: () => {},
};

export default connect((state) => ({
  LoginReducer: state.LoginReducer,
}))(withRouter(AuthForm));
